import React, { lazy, Suspense } from 'react';

const LazyCartConfiguratorPage = lazy(() => import('./CartConfiguratorPage'));

const CartConfiguratorPage = (props: React.JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyCartConfiguratorPage {...props} />
  </Suspense>
);

export default CartConfiguratorPage;
